import { z } from 'zod'

import {
	RECALL_EVENT_OUTCOME_OPTIONS,
	RECALL_EVENT_TYPE_OPTIONS,
} from '#app/routes/mocra+/_form+/intake-options.ts'

export const RecallEventEntrySchema = z.object({
	type: z.enum(
		RECALL_EVENT_TYPE_OPTIONS.map((option) => option.value) as [
			(typeof RECALL_EVENT_TYPE_OPTIONS)[number]['value'],
			...string[],
		],
	),
	year: z
		.string({
			required_error: 'Enter the year of the event.',
		})
		.regex(/^\d{4}$/, 'Enter a 4-digit year.'),
	product: z
		.string({
			required_error: 'Name the product, SKU family, or scope.',
		})
		.min(1, 'Name the product, SKU family, or scope.'),
	outcome: z.enum(
		RECALL_EVENT_OUTCOME_OPTIONS.map((option) => option.value) as [
			(typeof RECALL_EVENT_OUTCOME_OPTIONS)[number]['value'],
			...string[],
		],
	),
})

export type RecallEventEntry = z.infer<typeof RecallEventEntrySchema>
